// extracted by mini-css-extract-plugin
export default {"days":"weekdays_days__mqUEr","active":"weekdays_active__fm3c5"};